import React from "react";
import { useTheme } from "react-native-paper";
import { View, StyleSheet } from "react-native";
import { ThemeType } from "../../theme/theme";

/**
 * Inline Layout Component
 *
 * Add styling to the inline-container element by passing in a "style" object. Set L&R margins to "auto" to center the component
 */

interface IContainer {
  theme: ThemeType;
  space?: keyof ThemeType["spacing"];
  verticalSpace?: keyof ThemeType["spacing"];
  color?: string;
  cropEndSpace?: boolean;
  children: JSX.Element[] | JSX.Element;
}

interface IInline {
  style?: Record<string, any>;
  space?: keyof ThemeType["spacing"];
  verticalSpace?: keyof ThemeType["spacing"];
  children: JSX.Element[] | JSX.Element;
  cropEndSpace?: boolean;
}

const getChildrenStyle = (
  { theme, space = "medium", verticalSpace = "none", cropEndSpace = true, children }: IContainer,
  index: number
) => {
  const childStyle: any[] = [
    {
      marginRight: theme.spacing[space],
    },
  ];
  if (index === 0) {
    childStyle.push({
      marginLeft: theme.spacing[space],
    });
  }
  if (verticalSpace) {
    childStyle.push({
      marginVertical: theme.spacing[verticalSpace],
    });
  }
  if (cropEndSpace) {
    if (index === 0) {
      childStyle.push({
        marginLeft: 0,
      });
    }
    if (index === React.Children.count(children) - 1) {
      childStyle.push({
        marginRight: 0,
      });
    }
  }
  return childStyle;
};

export const Inline = (props: IInline) => {
  const theme = useTheme() as ThemeType;
  return (
    <View style={StyleSheet.flatten([styles.container, props.style])}>
      {React.Children.toArray(props.children).map((item, index) => (
        <View style={getChildrenStyle({ ...props, theme }, index)} key={index}>
          {item}
        </View>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
  },
});
